import React from "react";
import { Instagram, ArrowUpRight } from "lucide-react";

const ASSET_BASE = "https://customer-assets.emergentagent.com/job_stac-detail-book/artifacts";

const CLIENTS = [
  {
    name: "Chem Campbell",
    role: "Professional Footballer",
    instagram: "chemc10",
    image: "/gallery/trustedby_chem_uniform.png",
  },
  {
    name: "Sebastian Revan",
    role: "Professional Footballer",
    instagram: "sebrevan",
    image: "/gallery/trustedby_seb_uniform.png",
  },
];

export default function TrustedBy() {
  return (
    <section
      id="trusted-by"
      data-testid="trusted-by-section"
      className="px-6 md:px-12 lg:px-20 py-24 md:py-32 bg-[#0A0A0A] border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-12 gap-10 items-end mb-12">
          <div className="md:col-span-7">
            <div className="overline mb-3">— Trusted By</div>
          </div>
          <div className="md:col-span-4 md:col-start-9">
            <p className="text-white/55 text-sm leading-relaxed">
              A growing list of clients who trust STAC with their cars.
            </p>
          </div>
        </div>

        <ul
          data-testid="trusted-by-list"
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-x-5 gap-y-10"
        >
          {CLIENTS.map((c) => (
            <li
              key={c.name}
              data-testid={`trusted-by-card-${c.instagram}`}
              className="group"
            >
              <a
                href={`https://instagram.com/${c.instagram}`}
                target="_blank"
                rel="noopener noreferrer"
                className="block"
                aria-label={`${c.name} on Instagram`}
              >
                <div className="relative overflow-hidden bg-[#111] aspect-[4/5] mb-4">
                  <img
                    src={c.image}
                    alt={`${c.name} — STAC client`}
                    loading="lazy"
                    className="w-full h-full object-cover object-center transition-transform duration-[1200ms] ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-black/0 group-hover:bg-black/15 transition-colors duration-500" />
                </div>

                <div className="font-display text-lg md:text-xl font-light tracking-tight text-white leading-tight">
                  {c.name}
                </div>
                <div className="mt-1 text-[10px] tracking-[0.22em] uppercase text-white/50">
                  {c.role}
                </div>
                <div className="mt-3 inline-flex items-center gap-1.5 text-xs tracking-[0.18em] uppercase text-white/75 group-hover:text-white transition-colors">
                  <Instagram className="h-3.5 w-3.5" />
                  <span>@{c.instagram}</span>
                  <ArrowUpRight className="h-3 w-3 opacity-60 group-hover:opacity-100 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all" />
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
